import React, { useContext, useEffect } from 'react';

import Seo from '../components/Seo';
import FadeTransition from './../components/fadeTransition';
import { GatsbyImage } from 'gatsby-plugin-image';

import { context } from './../components/context';
import WeekNav from './weekNav';
import Button from './button';
import ChallengeTemplate from './challengeTemplate';
import { Wrapper, ContentWrapper, SidebarWrapper } from './Layout';
import ClientOnly from './ClientOnly';

const WeeklyTemplate = ({ pageContext, location }) => {
  const appContext = useContext(context);
  const { setDisplayWeek, savedChallenges } = appContext;
  const week = pageContext ? pageContext.week : appContext.displayWeek;
  const content = appContext.content[week];
  const weekString = `week${week}`;

  useEffect(() => {
    setDisplayWeek(week);
  }, [week, setDisplayWeek]);

  return (
    <>
      <Seo title={`Week ${week}`} />

      <FadeTransition>
        <ClientOnly>
          {savedChallenges?.[weekString] === undefined ? (
            <Wrapper>
              <ContentWrapper>
                <WeekNav
                  displayWeek={content.week_number}
                  currentWeek={appContext.currentWeek}
                  weekTitle='What are you giving a try this week?'
                />
                {content.choices.map((choice, index) => (
                  <Button
                    key={choice.id}
                    gatsbyLink={true}
                    to={`/week${week}/choice${index + 1}`}>
                    {choice.title}
                  </Button>
                ))}
              </ContentWrapper>
              <SidebarWrapper>
                <GatsbyImage
                  image={content.topImage.asset.gatsbyImageData}
                  alt=''
                  objectFit='contain'
                  placeholder='blurred'
                />
              </SidebarWrapper>
            </Wrapper>
          ) : (
            <ChallengeTemplate
              pageContext={{
                week,
                choice: savedChallenges[weekString],
                index: savedChallenges[weekString],
              }}
              location={location}
            />
          )}
        </ClientOnly>
      </FadeTransition>
    </>
  );
};

export default WeeklyTemplate;
